import * as types from './mutation-types'
import {ADD_CONTACT_SUPPLIER, ADD_NEXT_CONTACTS, UPDATE_CONTACT} from "./mutation-types";

export default {
  [types.ADD_CONTACTS](state, data) {
    state.contacts = data.contacts
  },
  [types.ADD_CONTACT](state, data) {
    state.contacts.push(data)
  },
  [types.SET_AVATAR] (state, {id, avatar}) {
    state.contacts = state.contacts.map((contact) => { if (contact.id == id) {contact.avatar = avatar} return contact })
  },
  [types.UPDATE_CONTACT] (state, data) {
    state.contacts = state.contacts.map((contact) => { if (contact.id == data.id) {contact = data} return contact })
  },

  [types.ADD_SCROLL_CONTACTS_DATA] (state, {data, query}) {
    const contacts = Array.isArray(data.data) ? data.data : Object.values(data.data)
    if(state.contactScrollMeta.currentQuery !== query || data.current_page === 1 ) {
      state.contactScroll = contacts
    } else {
      state.contactScroll = state.contactScroll.concat(contacts)
    }
    state.contactScrollMeta.current_page = data.current_page
    state.contactScrollMeta.last_page = data.last_page
    state.contactScrollMeta.currentQuery = query
  },

  [types.ADD_NEXT_CONTACTS] (state, data) {
    state.contactScroll = [...state.contactScroll, ...data.contacts]
  },

  [types.ADD_CONTACT_SUPPLIERS] (state, data) {
    state.contactSuppliers = data
  },

  [types.ADD_CONTACT_SUPPLIER] (state, data) {
    state.contactSuppliers.push(data)
  },
  [types.CONTACTS_STATS](state, data) {
    state.contactStats = data
  },
  

}
